module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Quote#1-ff70b80c2cea4ce263bcc1ebe8ccbfd328d254d6b367c3e99f50a886ef3ade68.svg";